import React from "react";
import { DIWALI_BANNER_LANTERNS } from "../../../utils/constants/Navbar";
import "../../../styles/diwaliTheme.css";

/** Side nav card: Diwali wishes from the Seekho team, with lanterns rising. */
const DiwaliBanner = () => {
  return (
    <div className="relative w-full overflow-hidden rounded-xl bg-[linear-gradient(135deg,#efedfc,#fff4e6)] px-3 py-2.5">
      <p className="relative text-[13px] font-semibold text-[#3c3489]">
        Happy Diwali
      </p>
      <p className="relative mt-0.5 pr-14 text-[11px] leading-snug text-[#6b66c4]">
        Warm wishes from the Seekho team
      </p>
      {DIWALI_BANNER_LANTERNS.map((l) => (
        <svg
          key={l.right}
          viewBox="0 0 14 22"
          aria-hidden="true"
          className="diwali-lantern pointer-events-none absolute"
          style={{
            right: l.right,
            bottom: l.bottom,
            width: l.width,
            height: l.width * 1.6,
            animationDelay: `${l.delay}s`,
          }}
        >
          <path d="M3 2H11L13 9L7 16L1 9Z" fill="#f59e0b" />
          <path d="M3 2H11L7 16Z" fill="#fbbf24" />
          <circle cx="7" cy="9" r="1.6" fill="#fff7d6" />
          <path d="M6 16V21M8 16V21" stroke="#f59e0b" strokeWidth="0.8" />
        </svg>
      ))}
    </div>
  );
};

export default DiwaliBanner;
